// Generated by ReScript, PLEASE EDIT WITH CARE

import * as TopNavigationBar__Background$PrezzeeRibbon from "../../common/TopNavigationBar/TopNavigationBar__Background.bs.js";
import * as TopNavigationBar__Theme__Personal$PrezzeeRibbon from "./TopNavigationBar__Theme__Personal.bs.js";

var include = TopNavigationBar__Background$PrezzeeRibbon.Component(TopNavigationBar__Theme__Personal$PrezzeeRibbon.Theme);

var Styles = include.Styles;

var FadeBackground = include.FadeBackground;

var StaticBackground = include.StaticBackground;

export {
  Styles ,
  FadeBackground ,
  StaticBackground ,
}
/* include Not a pure module */
